import { api } from "./api";

export const getCategorias = (numeroPagina: string) =>
  api.get(`Categoria/buscartodos/${numeroPagina}`);
export const getTodasCategorias = async () => {
  try {
    const response = await api.get(`Categoria/select`)
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
export const getCategoria = (cdCategoria: number) => api.get(`Categoria/buscar/${cdCategoria}`);